import router from '../router'
import axios from 'axios'
const app = require('../main');

export default {
  actions: {
    about(ctx, index) {
      if (index == 'project') {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projects/item?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
            .then(response => {
              loader.hide();
              ctx.commit('updateAbout', response.data.item.description);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      } else if(index == 'projectTask') {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTasks/item?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${router.history.current.query.taskId}`)
            .then(response => {
              loader.hide();
              ctx.commit('updateAbout', response.data.item.description);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      } else if (index == 'engagement') {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/engagements/item?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}`)
            .then(response => {
              loader.hide();
              ctx.commit('updateAbout', response.data.item.description);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      } else if (index == 'engagementTask') {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/engagementTasks/item?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}&engagementTaskId=${router.history.current.query.taskId}`)
            .then(response => {
              loader.hide();
              ctx.commit('updateAbout', response.data.item.description);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      } else if (index == 'bu') {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnits/item?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}`)
            .then(response => {
              loader.hide();
              ctx.commit('updateAbout', response.data.item.description);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      } else if (index == 'buTask') {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnitTasks/item?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}&businessUnitTaskId=${router.history.current.query.taskId}`)
            .then(response => {
              loader.hide();
              ctx.commit('updateAbout', response.data.item.description);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      }
    },
  },
  mutations: {
    updateAbout(state, list) {
      state.about = list
    }
  },
  state: {
    about: null,
  },
  getters: {
    getAbout(state) {
      return state.about
    }
  }
}